import type { Pairing } from '@swiss-magic/shared-types';

type Player = Pairing['whitePlayer'];

/**
 * Player label inside a pairing — name, rating, optional swap-highlight button.
 * Used by both PairingRow and PairingCard.
 */
export function PlayerLabel({
  player,
  selectable,
  selected,
  onSelect,
  ratingClass,
}: {
  player: Player;
  selectable: boolean;
  selected: boolean;
  onSelect?: (playerId: string) => void;
  ratingClass: string;
}) {
  const displayName = `${player.firstName} ${player.lastName}`;
  const ratingSpan = player.rating ? (
    <span className={`ml-1 ${ratingClass}`}>({player.rating})</span>
  ) : null;

  if (selectable && onSelect) {
    return (
      <button
        className={`cursor-pointer rounded px-1 hover:bg-muted ${
          selected ? 'ring-2 ring-amber-500' : ''
        }`}
        data-testid={`swap-player-${player.id}`}
        onClick={() => onSelect(player.id)}
      >
        {displayName}
        {ratingSpan}
      </button>
    );
  }

  return (
    <>
      {displayName}
      {ratingSpan}
    </>
  );
}
